import type { CreateMessageTemplateDto } from "@/dtos/CreateMessageTemplateDto";
import type { UpdateMessageTemplateDto } from "@/dtos/UpdateMessageTemplateDto";
import api from "@/services/api";
import { useMutation, useQuery } from "@tanstack/react-query";

export const useCreateMessageTemplate = () => {
  return useMutation({
    mutationKey: ["create-message-template"],
    mutationFn: async (createMessageTemplateDto: CreateMessageTemplateDto) => {
      const response = await api.post(
        "/comment-templates",
        createMessageTemplateDto,
      );
      return response.data;
    },
  });
};

export const useGetMessageTemplates = () => {
  return useQuery({
    queryKey: ["message-templates"],
    queryFn: async () => {
      const response = await api.get("/comment-templates");
      return response.data;
    },
  });
};

export const useUpdateMessagesTemplates = () => {
  return useMutation({
    mutationKey: ["update-message-template"],
    mutationFn: async (updateMessageTemplateDto: UpdateMessageTemplateDto) => {
      const response = await api.patch(
        `/comment-templates/${updateMessageTemplateDto.id}`,
        {
          title: updateMessageTemplateDto.title,
          content: updateMessageTemplateDto.content,
        },
      );
      return response.data;
    },
  });
};

export const useDeleteMessageTemplate = () => {
  return useMutation({
    mutationKey: ["delete-message-template"],
    mutationFn: async (id: string) => {
      const response = await api.delete(`/comment-templates/${id}`);
      return response.data;
    },
  });
};
